<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.9889 3.50391V0.878906L7.32227 4.37891L10.9889 7.87891V5.25391C14.0231 5.25391 16.4889 7.60766 16.4889 10.5039C16.4889 11.3877 16.2598 12.2277 15.8473 12.9539L17.1856 14.2314C17.9006 13.1552 18.3223 11.8777 18.3223 10.5039C18.3223 6.63641 15.0406 3.50391 10.9889 3.50391ZM10.9896 15.7548C7.95542 15.7548 5.48958 13.401 5.48958 10.5048C5.48958 9.62102 5.71875 8.78102 6.13125 8.05477L4.79292 6.77727C4.07792 7.85352 3.65625 9.13102 3.65625 10.5048C3.65625 14.3723 6.93792 17.5048 10.9896 17.5048V20.1298L14.6562 16.6298L10.9896 13.1298V15.7548Z"
  />
</template>
